import styled from 'styled-components';
import {
	media,variables
} from 'styleUtils';

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const OptionsWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  > div:first-of-type {
    margin-bottom: ${props => props.multiple ? '10px' : 0};
  }
  ${media.tablet`
    flex-direction: row;
    > div {
      flex: 1 1 0px
      margin-bottom: 0
    }
    > div:first-of-type {
      margin-right: ${props => props.multiple ? '10px' : 0};
      margin-bottom: unset;
    }
    > div:last-of-type {
      margin-left: ${props => props.multiple ? '10px' : 0};
    }
  `}

`

const Divider = styled.div`
  width: 200px;
  text-align: center;
  border-bottom: 1px solid rgb(216,216,216);
  line-height: 0.1em;
  margin: 40px 0;
  span {
    background: ${variables.white};
    color: ${variables.darkGrey};
    font-size: 1rem;
    padding: 0 20px;
    width: 30px;

    ${media.desktop`
      background: ${props => props.whiteBg ? variables.white : variables.lightGrey };
    `}
  }
`

const TitleContainer = styled.div`
  margin-bottom: 40px;
  margin-top: 40px;
  a {
    border-bottom: 1px solid;
    font-size: .75rem;
  }
`

const Title = styled.h2`
  margin-top: 20px;
  font-size: 16px;
  margin-bottom: 0px;
  ${props => props.medCheckout && 'margin-top: 0 !important; font-size: 16px; margin-bottom: 5px;'}
`

export {
	Divider,
	OptionsWrapper,
	Title,
	TitleContainer,
	Wrapper,
}
